import { NgTemplateOutlet } from '@angular/common';
import { Component, inject } from '@angular/core';

import { ChdChipPresenter } from '@cp-produkte/cruise-hospitality-design';

import { ComponentsModule } from '../components.module';

/**
 * App-local renderer that draws `ChdChip` with the legacy `.spa-day` token
 * (label + a clickable close icon). Plugged into the chd chip slot via the
 * backend provider, e.g. `provideChdDxBackend({ chip: ChdChipSpaRenderer })`.
 *
 * The close affordance remains a `spa-icon` to preserve the legacy markup.
 */
@Component({
  selector: 'spa-chd-chip-renderer',
  imports: [ComponentsModule, NgTemplateOutlet],
  templateUrl: './chd-chip-spa-renderer.component.html',
  styleUrl: './chd-chip-spa-renderer.component.scss',
})
export class ChdChipSpaRenderer {
  protected readonly presenter = inject(ChdChipPresenter);

  protected onRemove(event?: Event): void {
    if (this.presenter.viewState().disabled) {
      return;
    }

    event?.preventDefault();
    this.presenter.remove();
  }
}
